// Score → emoji + legend, ported verbatim from GolfGamesScorecard's
// utils/scoreHelpers.ts so the scorecard reads identically.
export function scoreEmoji(score, par) {
  if (score === 1) return '🕳️'
  if (score === 8) return '⛄'
  const diff = score - par
  if (diff <= -3) return '🦅🦅'
  if (diff === -2) return '🦅'
  if (diff === -1) return '🐦'
  if (diff === 0) return '⛳'
  if (diff === 1) return '😬'
  if (diff === 2) return '😱'
  return '💀'
}

export const SCORE_LEGEND =
  '🕳️ Ace  🦅🦅 Dbl Eagle  🦅 Eagle  🐦 Birdie  ⛳ Par  😬 Bogey  😱 Dbl Bogey  💀 Triple  ⛄ Snowman'
